import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, type CommonCursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { PaginatedRailsDataObjects } from 'models/service';
import type { OrganizationScope } from '../models';

type PublicOrganizationParams = {
  community_id?: string;
  group_id?: string;
  scope?: OrganizationScope;
} & CommonCursorPaginationRailsParams;

export const getPublicOrganizations = async (params: PublicOrganizationParams) =>
  apiClient.get<
    PaginatedRailsDataObjects<components['schemas']['OrganizationBase']>,
    ApiClientResponse<PaginatedRailsDataObjects<components['schemas']['OrganizationBase']>>
  >(routes.organizations.public.find, {
    params,
  });
